import { CircularProgress } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import Form from "../../components/form";
import api from "../../services/api";
import AppContext from "../../container/context";
import ActionTable from "../../components/table/ActionTable";

export default function Transportadora({match, history}) {
  const { notification } = useContext(AppContext);

  const [turmaId] = useState(Number(match.params.id));
  const [carregando, setCarregando] = useState(false);
  const [turma, setTurma] = useState({});
  const [comboEscolas, setComboEscolas] = useState([]);

  useEffect(() => {
    if (turmaId > 0){
      carregar();
    } else {
      carregarComboEscolas();
    }
  }, []);

  const carregarComboEscolas = () => {
    api.get("escolas/listar", { ativas: true }).then(escolas => {
      setComboEscolas(escolas);
    });
  };

  const carregar = () => {
    setCarregando(true);

    api
      .get("turmas/carregar", { id: turmaId })
      .then(turma => {
        turma.valorMaterial = turma.valorMaterialCentavos ? (turma.valorMaterialCentavos/100).toFixed(2) : 0;

        setTurma(turma);
        setCarregando(false);
      })
      .catch((err) => {
        notification("error", "Não foi possível carregar a turma");
        console.log(err);
        setCarregando(false);
      });
  };

  const salvar = form => {
    setTurma(form);

    if (turmaId) {
      const turmaSalvar = {id: turmaId, ...form};

      turmaSalvar.valorMaterialCentavos = turmaSalvar.valorMaterial*100;

      api
        .post("turmas/editar", turmaSalvar)
        .then((res) => {
          notification("success", "Turma editada!");

          history.goBack();
        })
        .catch((err) => {
          if(!err || !err.data || !err.data.length) return notification("error", "Não foi possível editar a turma. Verifique os dados e tente novamente.");

          if(err.data.includes(1)) notification("error", "Nome inválido.");
          if(err.data.includes(2)) notification("error", "Valor de material inválido.");
        });      
    } else {
      const turmaInserir = {...form};

      turmaInserir.valorMaterialCentavos = turmaInserir.valorMaterial*100;

      api
        .put("turmas/inserir", turmaInserir)
        .then((res) => {
          notification("success", "Turma inserida!");

          history.goBack();
        })
        .catch((err) => {
          if(!err || !err.data || !err.data.length) return notification("error", "Não foi possível editar a turma. Verifique os dados e tente novamente.");

          if(err.data.includes(1)) notification("error", "Nome inválido.");
          if(err.data.includes(2)) notification("error", "Valor de material inválido.");
          if(err.data.includes(3)) notification("error", "Escola inválida.");
        });
    }
  };

  const camposTurma = () => {
    let campos = {
      nome: {
        label: "Nome",
        type: "text",
        value: turma.nome,
        required: true
      }
    };

    if(turmaId){
      campos.escola = {
        label: 'Escola',
        type: 'text',
        value: turma.escolaNomeFantasia,
        readOnly: true
      }
    } else {
      campos.escolaId = {
        label: "Escola",
        type: "select",
        value: turma.escolaId,
        array: {
          data: comboEscolas,
          value: "id",
          desc: "nomeFantasia",
        },
        emptyItem: true,
        emptyItemText: "(Selecione)",
        required: true
      }
    }

    campos = {
      ...campos,
      valorMaterial: {
        label: 'Valor do material (R$)',
        type: 'number',
        value: turma.valorMaterial
      },
      kitAltura: {
        label: "Altura (cm)",
        type: "number",
        value: turma.kitAltura,
        required: false,
        space: 3,
      },
      kitLargura: {
        label: "Largura (cm)",
        type: "number",
        value: turma.kitLargura,
        required: false,
        space: 3,
      },
      kitComprimento: {
        label: "Comprimento (cm)",
        type: "number",
        value: turma.kitComprimento,
        required: false,
        space: 3,
      },
      kitPeso: {
        label: "Peso (g)",
        type: "number",
        value: turma.kitPeso,
        required: false,
        space: 3,
      },
      inativacao: {
        label: "Inativação",
        type: "date",
        value: turma.inativacao
      }
    }

    return campos;
  };

  const fTurma = {
    title: "Turma",
    form: camposTurma(),
    submit: {
      label: "Salvar",
      action: salvar,
    },
    history,
    close: true,
  };
  
  return (
    <div>
      {carregando ? <CircularProgress /> : <Form formData={fTurma} />}
    </div>
  );
}
